import React from "react";
import { SponsorshipCardByDurationStyle } from "../../pages/Sponsors/Configuration.style";

const borderStyle = {
  border: "2px solid #f28809",
  borderRadius: "8px",
  padding: "12px 20px",
  marginTop: "16px",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  fontWeight: 500,
  fontSize: "15px",
  background: "#fff",
};

const SponsorshipByDurationCard = ({ heading, stats }) => {
  return (
    <SponsorshipCardByDurationStyle>
      <div className="mainDivStyle">
        <div className="headingStyle">{heading}</div>
        <div style={{ flex: 1 }} />
        <div className="borderStyle">
          <span>30 Days = {stats["30days"] ?? 0}</span>
          <span>90 Days = {stats["60days"] ?? 0}</span>
          <span>180 Days = {stats["180days"] ?? 0}</span>
          <span>365 Days = {stats["365days"] ?? 0}</span>
        </div>
      </div>
    </SponsorshipCardByDurationStyle>
  );
};

export default SponsorshipByDurationCard;
